import * as React from 'react';

import { MatchResultInfo } from '@/components/layouts/Modal/MatchDetail';
import { oneWordRaceEventNameMapper } from '@/lib/race';
import { ScoreType } from '@/modelTypes';

import { Rank, ShortendRaceEventName, StyledLink, Wrapper } from './style';

interface ScoreProps {
  scoreData: ScoreType;
  gradeName: string;
  registrationNum: number;
  openRaceResultModal: (
    matchResult: MatchResultInfo,
    highlightTarget: number,
  ) => void;
}

const ScoreData: React.FC<ScoreProps> = ({
  scoreData,
  gradeName,
  registrationNum,
  openRaceResultModal,
}) => {
  const dummyResult = '　';
  const viewRank = (s: ScoreType) => {
    if (s.rank > 0) {
      return String(s.rank);
    }
    if (s.personalStatus) {
      return s.personalStatus;
    }

    return '未';
  };
  const linkClickEvent = () => {
    const tmpMatchResult: MatchResultInfo = {
      raceDate: scoreData.heldDate,
      velodromeCode: Number(scoreData.velodromeCode),
      grade: gradeName,
      raceNum: scoreData.raceNum.toString(),
      raceClassName: '',
      rankMine: 0,
      statusMine: '',
      rankOpponent: 0,
      statusOpponent: '',
    };
    openRaceResultModal(tmpMatchResult, registrationNum);
  };

  return (
    <Wrapper>
      {scoreData.personalStatus === '欠場' ? (
        <>欠場</>
      ) : (
        <>
          {scoreData.raceNum === 0 ? (
            <>{dummyResult}</>
          ) : (
            <StyledLink onClick={() => linkClickEvent()}>
              <ShortendRaceEventName>
                {oneWordRaceEventNameMapper(scoreData.raceEventName)}
              </ShortendRaceEventName>
              <Rank>
                {viewRank(scoreData)}
                {scoreData.hasBackGet && <sup>B</sup>}
              </Rank>
            </StyledLink>
          )}
        </>
      )}
    </Wrapper>
  );
};

export default ScoreData;
